import { CatalogView } from './catalog';

export function CatalogScreen() {
  return (
    <div className="h-full w-full overflow-hidden p-4 md:p-6">
      <CatalogView />
    </div>
  );
}
